import Cookies from 'universal-cookie';
import JwtDecode from 'jwt-decode';

export function checkTokenExpirationMiddleware(){
    try{
        let cookies = new Cookies();
        let token = cookies.get("evarsv_aut10");
        let tkCookieDecoded = JwtDecode(token);
        let isValid = tkCookieDecoded.exp > Date.now()/1000;
        let user = {};
        if (isValid) {
            user = {
                UserId: parseInt(tkCookieDecoded.UserID),
                TourismCompanyID: parseInt(tkCookieDecoded.TourismCompanyID),
                SupplierType: tkCookieDecoded.SupplierType,
                Token: token
            };
        }
        else {
            cookies.remove("evarsv_aut10", { domain: 'evareservation.azurewebsites.net', path: '/' });
            throw new Error("token expired");
        }
        return user;
    }
    catch(e){
        return null;
    }
}
